var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99583 2.29268L4.83924 3.13609C5.04757 3.34442 5.33021 3.46143 5.625 3.46143H8.75174C8.82743 3.46143 8.88889 3.52289 8.88889 3.59859V7.66421C8.88889 7.73991 8.82743 7.80136 8.75174 7.80136H1.24826C1.17257 7.80136 1.11111 7.73991 1.11111 7.66421V2.34859C1.11111 2.27289 1.17257 2.21143 1.24826 2.21143H3.8C3.87361 2.21143 3.9441 2.2406 3.99583 2.29268ZM0.28125 1.10032C0.126042 1.10032 0 1.22636 0 1.38157V8.63157C0 8.78678 0.126042 8.91282 0.28125 8.91282H9.71875C9.87396 8.91282 10 8.78678 10 8.63157V2.63157C10 2.47636 9.87396 2.35032 9.71875 2.35032H5.7441C5.66771 2.35032 5.59479 2.32011 5.54063 2.26595L4.4566 1.18192C4.40417 1.12949 4.33333 1.09998 4.25903 1.09998H0.28125V1.10032Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/FolderIcon.b8c6f9204036f92b3fc8b879a310d278.svg";
export { ForwardRef as ReactComponent };